module.exports = __webpack_public_path__ + "static/img/logo.d39d1f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brief/logo.png
// module id = dhLP
// module chunks = 1